export default __webpack_public_path__ + "static/media/vuesax-linear-teacher.a7d8f3f3.svg";